import React from "react";
import { useTranslation } from "react-i18next";

const AddressAccordion = ({
  zipCode = "",
  setZipCode,
  getLocationFromZip,
  city = "",
  setCity,
  stateName = "",
  setStateName,
  country = "",
  setCountry,
  address = "",
  setAddress,
}) => {
  const { t } = useTranslation();

  return (
    <div className="accordion-item bg-transparent border-0">
      <h3 className="accordion-header">
        <button
          className="accordion-button bg-transparent p-0 shadow-none"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#panelsStayOpen-collapseAddress"
          aria-expanded="true"
          aria-controls="panelsStayOpen-collapseAddress"
        >
          {t("Address Data")}
        </button>
      </h3>
      <div
        id="panelsStayOpen-collapseAddress"
        className="accordion-collapse collapse show"
      >
        <div className="accordion-body p-0 pt-4">
          {/* Zipcode, Fetch Location, City, State, Country */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <div className="d-flex flex-wrap align-items-end">
              <div className="flex-grow-1 mb-3 mb-lg-0 me-lg-3">
                <label className="d-block fs-sm fw-semibold mb-2">
                  {t("Zipcode")}
                </label>
                <input
                  type="text"
                  className="form-control fs-sm border border-gray-300 shadow-none"
                  placeholder={t("Zipcode")}
                  value={zipCode}
                  onChange={(e) => {
                    setZipCode(e.target.value);
                  }}
                />
              </div>

              <div className="d-flex align-items-end flex-grow-0 flex-shrink-0 w-auto mb-3 mb-lg-0 me-lg-3">
                <button
                  className="btn btn-primary"
                  onClick={getLocationFromZip}
                >
                  {t("Fetch Location by zipcode")}
                </button>
              </div>

              <div className="flex-grow-1 mb-3 mb-lg-0 me-lg-3">
                <label className="d-block fs-sm fw-semibold mb-2">
                  {t("City")}
                </label>
                <input
                  type="text"
                  className="form-control fs-sm border border-gray-300 shadow-none"
                  placeholder={t("City")}
                  value={city}
                  onChange={(e) => {
                    setCity(e.target.value);
                  }}
                />
              </div>

              <div className="flex-grow-1 mb-3 mb-lg-0 me-lg-3">
                <label className="d-block fs-sm fw-semibold mb-2">
                  {t("State")}
                </label>
                <input
                  type="text"
                  className="form-control fs-sm border border-gray-300 shadow-none"
                  placeholder={t("State")}
                  value={stateName}
                  onChange={(e) => {
                    setStateName(e.target.value);
                  }}
                />
              </div>

              <div className="flex-grow-1 mb-3 mb-lg-0 me-lg-3">
                <label className="d-block fs-sm fw-semibold mb-2">
                  {t("Country")}
                </label>
                <input
                  type="text"
                  className="form-control fs-sm border border-gray-300 shadow-none"
                  placeholder={t("Country")}
                  value={country}
                  onChange={(e) => {
                    setCountry(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>

          {/* Address Line 1 */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <label className="d-block fs-sm fw-semibold mb-2">
              {t("Address Line 1")}
            </label>
            <input
              type="text"
              className="form-control fs-sm border border-gray-300 shadow-none"
              placeholder={t("Location")}
              value={address}
              onChange={(e) => {
                setAddress(e.target.value);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddressAccordion;
